<template>
  <div>
    <!-- 批量标识 -->
    <el-dialog :visible.sync="dialogVisible" width="480px" :title="$t('message.batchIdentification')">
      <div class="content">
        <el-radio-group v-model="edit_status">
          <el-radio :label="1">待维护</el-radio>
          <el-radio :label="2">维护完成</el-radio>
          <el-radio :label="3">无需维护</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="switchEditStatus">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    tableData: { type: Array },
    checkList: { type: Array },
  },
  data() {
    return {
      dialogVisible: false,
      edit_status: '',
    };
  },
  methods: {
    // 保存
    switchEditStatus() {
      let datas = {
        edit_status: this.edit_status,
        sys_code_set: []
      }
      this.checkList.forEach(item => {
        datas.sys_code_set.push(item.sys_code)
      })
      this.$api.productManagementApi.switchEditStatus(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.tableData.forEach(item => {
          if (item.checked) {
            item.edit_status = this.edit_status
            item.checked = false
          }
        })
        this.$forceUpdate()
      })
    },
  }
}
</script>
<style lang='scss' scoped></style>